import React from 'react';
import * as theme from '@fiverr-private/theme/src/shared/themeVars';
import { Typography } from '@fiverr-private/typography';
import { Types } from '@fiverr-private/theme';
import { Container } from '@fiverr-private/layout_components';

interface ContentProps {
    isIndependent?: boolean;
    plainHtml: string;
    as?: keyof typeof theme.elements.typography.heading | keyof typeof theme.elements.typography.body;
    color?: Types.SelectorTypographyColorsType;
    className?: string;
}

export const Content = ({ plainHtml, as = 'p', color = 'inherit', isIndependent = false, className }: ContentProps) =>
    isIndependent ? (
        <Container
            className={className}
            color={color}
            dangerouslySetInnerHTML={{
                __html: plainHtml,
            }}
        />
    ) : (
        <Typography
            as={as}
            className={className}
            color={color}
            dangerouslySetInnerHTML={{
                __html: plainHtml,
            }}
        />
    );
